module.exports = __webpack_public_path__ + "img/naverblog.0f691a2d.svg";